var exports = {
  "k": "x234b8571--e45d01--container",
  "h": "x234b8571--e45d01--description",
};

module.exports = exports;
